import styled from 'styled-components';
export const Panel = styled.div `
	margin: 0;
	padding: 0;
`;
